import { ModuleConfig } from "../../types/ModuleConfig";

/**
 * Authentication Module Config
 *
 * This module is consumed via `./index.ts` exports (UnifiedLoginModal,
 * SecureMembershipButton, AuthContext queries, etc.) rather than by
 * registering routes/nav. The moduleConfig exists only so the cross-tenant
 * drift scanner can read a version string and track this module alongside
 * the route-based modules on the Module Upgrade Matrix.
 *
 * Integration guide: see ./CLAUDE.md
 */
const authenticationModuleConfig: ModuleConfig = {
    id: "authentication",
    name: "Authentication",
    description: "Unified login + SMS/email verification + username/password + myClient AuthContext",
    version: "1.2.0", // Shared email/SMS links, tenant profile policy and standardized login/security.
    enabled: true,
    category: "core",
    order: 0,
    icon: "🔐",
    navigation: [],
    permissions: {
        view: [],
        create: [],
        edit: [],
        delete: [],
    },
    routes: [],
};

export default authenticationModuleConfig;
